import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import '../../../src/custom.css'
import Header from '../PageLayout/Header';
import Footer from '../PageLayout/Footer';
import { utils, writeFile } from 'xlsx';
import XLSIcon from "../../assets/images/dropdownFile.svg";
import { Select, Input, Switch, Drawer, Typography, Button } from 'antd';
import Loader from "../loader";
import Table from "antd/lib/table";
import { Tooltip, Collapse, Divider, DatePicker, Space, Dropdown, Menu, Modal as Confirm } from 'antd';
import { CloseOutlined } from "@ant-design/icons";
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import Edit_light from "../../assets/images/Edit_light.svg";
import Layout from '../Layout';
import { getallsupportdata, updateprioritydata, updateassigneddetails, updatestatusdetails } from '../../Redux/Actions/SupportActions';
import { getworkitemsupportdata } from '../../Redux/Actions/WorkItemAction';
import {
    fetchAllSupportdata, fetchAllActiveUSersData, fetchCallOrderdata, fetchusersupportaccessdata, fetchWorkItemswithsupport, fetchUserRoledata, fetchUsersFromNotification,
    fetchUsersByGroupId, fetchAllCompaniesdata, fetchSitesByCompanyId
} from "../../Redux/Api/fetch.api";
import VideoIcon from '../../assets/images/Edit_light.svg';
import videodemo from '../../assets/images/Edit_light.svg';
import Send from '../../assets/images/Edit_light.svg';
import CallingIcon from '../../assets/images/Edit_light.svg';
import Dummy from '../../assets/images/Edit_light.svg';
import CloseIcon from '../../assets/images/Edit_light.svg';
import MinimizeIcon from '../../assets/images/Edit_light.svg';
import More from '../../assets/images/Edit_light.svg';
import ChatBox from "./ChatBox";
import VideoCall from "./VideoCall"
import LogIcon from '../../assets/images/log.png'
import searchIcon from "../../assets/images/search_icon.svg";
import { getallcompanies } from '../../Redux/Actions/CompanyActions';
import ReloadIcon from "../../assets/images/reset_icon.svg";
import ApplyIcon from "../../assets/images/apply-icon.svg";
import AcknowledgeIcon from "../../assets/images/acknowledge.svg";
import UpdateIcon from "../../assets/images/update.svg";
import PhoneIcon from "../../assets/images/phone-icon.svg";
import MessageIcon from "../../assets/images/message-icon.svg";
import PlayIcon from "../../assets/images/play_circle.svg";
import PdfIcon from "../../assets/images/pdf_icon.svg";
import MicIcon from '@mui/icons-material/Mic';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AddIcCallSharpIcon from '@mui/icons-material/AddIcCallSharp';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import Add from "../../assets/images/Add.svg";
import * as url from "../../api/uri_helper";
import axios from "axios";
/*import { Modal } from 'antd';*/
import AttachmentIcon from '@mui/icons-material/Attachment';
import CollectionsIcon from '@mui/icons-material/Collections';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Modal, Carousel } from "react-bootstrap";
import { saveAs } from "file-saver";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getuserroleandmenu, getuserslistfromnotification } from '../../Redux/Actions/UsersActions';
import NotAuthorised from "../Authentication/NotAuthorised";
import { Howl } from 'howler';
import dayjs from 'dayjs';
import moment from 'moment';
import GroupIcon from '@mui/icons-material/GroupAddRounded';
import { useTranslation } from "react-i18next";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Title from "../Title";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import whatsapp from "../../assets/images/whatsapp.png";
import SMS from "../../assets/images/sms.png";
import video_call from "../../assets/images/video_option.svg";
import call_icon from "../../assets/images/call_option.svg";
import email_icon from "../../assets/images/mail_option.svg";
import chat_icon from "../../assets/images/chat_option.svg";
import AddManualSupport from "../Support/AddSupport";
import { UserOutlined } from '@ant-design/icons'; // Use Ant Design icon for the user
import { Breadcrumb } from "antd";
import AudioCall from "../Support/audiocall";
import Trash_light from "../../assets/images/Trash_light.svg";
//const SupportIndex = () => {
const SupportIndex = (props) => {
    const { handleVideo } = props;
    const { t } = useTranslation('support');
    const { REACT_APP_SUPPORT_PAGESIZE } = process.env;
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [assignedtable, setAssignedTable] = useState([]);
    const [acknowledgedtable, setAcknowledgedTable] = useState([]);
    const [closedtable, setClosedTable] = useState([]);
    const [pageSize, setPageSize] = useState(REACT_APP_SUPPORT_PAGESIZE);
    const [actionlist, setActionList] = useState([]);
    const history = useHistory();
    const [companyError, setCompanyError] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [newSupportCount, setNewSupportCount] = useState(0);
    const [showCarouselModal, setShowCarouselModal] = useState(false);
    const [showSupportModal, setShowSupportModal] = useState(false);
    const [ispriority, setIsPriority] = useState(false);
    const [companyId, setCompanyId] = useState();
    const [supportuserId, setSupportUserId] = useState();
    const [comingsupportId, setComingSupportId] = useState();
    const [siteId, setSiteId] = useState();
    const [showAddSupport, setShowAddSupport] = useState(false);
    const [allCompaniesData, setAllCompaniesData] = useState([]);
    const [attachmentType, setAttachmentType] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [roleName, setRoleName] = useState(null);
    const [allUserData, setAllUserData] = useState([]);
    const [allUserSupportData, setAllUserSupportData] = useState([]);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState(null);
    const [rangeEnd, setRangeEnd] = useState('');
    const [resetDisplay, setResetDisplay] = useState(false);
    const [rangeStart, setRangeStart] = useState('');
    const [sitesData, setSitesData] = useState([]);
    const [filteredUserOptions, setFilteredUserOptions] = useState([]);

    const handleSelect = (selectedIndex, e) => {
        setCurrentIndex(selectedIndex);
        const mediaElements = document.querySelectorAll('video, audio');
        mediaElements.forEach(element => {
            element.pause();
        });
    };
    const [allowAutoRefresh, setAllowAutoRefresh] = useState(false);

    const Attachment = {
        IMAGE: 1,
        VIDEO: 2,
        DOCUMENT: 3,
        VOICE: 4
    };

    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['5', '10', '20'],
            showSizeChanger: true,
        },
    });

    const [assignedoptions, setAssignedOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['5', '10', '20'],
            showSizeChanger: true,
        },
    });

    const [acknowledgedoptions, setAcknowledgedOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['5', '10', '20'],
            showSizeChanger: true,
        },
    });

    const [closedoptions, setClosedOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['5', '10', '20'],
            showSizeChanger: true,
        },
    });

    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    const [priority, setPriority] = useState(null)
    const [status, setStatus] = useState("")
    const [actiontaken, setActionTaken] = useState("")
    const [supportId, setSupportId] = useState();
    const [applyId, setApplyId] = useState();
    const [sitename, setSiteName] = useState("");
    const [workitemid, setWorkItemId] = useState();
    const [priorityindex, setPriorityIndex] = useState();
    const [callOrderIndex, setCallOrderIndex] = useState();
    const [statusindex, setStatusIndex] = useState();
    const [acknowledgeId, setAcknowledgeId] = useState();
    const loggedUserId = localStorage.getItem('UserId')
    const [isNewRequestOpen, setisNewRequestOpen] = useState(true);
    const [isAssignedOpen, setisAssignedOpen] = useState(true);
    const [isOnProcessedOpen, setisOnProcessedOpen] = useState(true);
    const [updateModal, setUpdateModal] = useState(false);
    const [applyModal, setApplyModal] = useState(false);
    const [acknowledgeModal, setAcknowledgeModal] = useState(false);
    const [supportAttachmentModal, setSupportAttachmentModal] = useState(false);
    const [AttachmentSrc, setAttachmentSrc] = useState();
    const [userId, setUserId] = useState();
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [filteredSupportOptions, setFilteredSupportOptions] = useState([]);
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);
    const [callOrderData, setCallOrderData] = useState([]);
    const [supportData, setSupportData] = useState([]);
    const { TextArea } = Input;
    const allUserTypes = useSelector((state) => state.allUserdata.users);
    const userRoledata = allUserTypes.data && allUserTypes.data.userRoleDetails;
    const userRole = userRoledata && userRoledata[0].roleName;
    const [technicianOptions, setTechnicianOptions] = useState({});
    const loginUserName = allUserTypes?.data?.userRoleDetails[0]?.firstName + " " + allUserTypes?.data?.userRoleDetails[0]?.lastName;
    const loginuserId = allUserTypes?.data?.userId;
    const EmailId = allUserTypes?.data?.userRoleDetails[0]?.emailId;
    const roleId = allUserTypes?.data?.userRoleDetails[0]?.roleId;

    const [chatBoxVisible, setChatBoxVisible] = useState(false);
    const [selectedChatContent, setSelectedChatContent] = useState(null);
    const [chatBoxes, setChatBoxes] = useState([]); // Array of chat boxes
    const [videoCalls, setVideoCalls] = useState([]); // Array of video calls
    const [maxChatBoxes, setMaxChatBoxes] = useState(4);
    const [exitingChatBoxes, setExitingChatBoxes] = useState([]);
    // const userName = allUserTypes?.data?.userRoleDetails[0]?.lastName + " " + allUserTypes?.data?.userRoleDetails[0]?.firstName;
    const intervalRef = useRef(null);

    const [audioCallInitiated, setAudioCallInitiated] = useState(false)
    const [audioCallContent, setAudioCallContent] = useState([])
    const currentUserName = allUserTypes?.data?.userRoleDetails[0]?.lastName + " " + allUserTypes?.data?.userRoleDetails[0]?.firstName;



    const cancelCall = () => {
        setAudioCallInitiated(false);
    }

    useEffect(() => {
        if (localStorage.getItem('tekaVerseToken') == null) {
            history.push("/");
        }
    }, []);

    useEffect(() => {
        //  getSupportDetails();
        getRoleDetails();
        getworkitemsupportdetails();
        getallusersdata();
        //getallusersbygroupid();
    }, []);

    useEffect(() => {
        getSupportDetails();
    }, [resetDisplay, showAddSupport]);

    const updateMaxChatBoxes = () => {

        if (window.innerWidth <= 600) {
            setMaxChatBoxes(1); // Mobile
        } else if (window.innerWidth <= 1024) {
            setMaxChatBoxes(2); // Tablets
        } else if (window.innerWidth <= 1440) {
            setMaxChatBoxes(3); // Small desktops
        } else {
            setMaxChatBoxes(4); // Large desktops
        }
    }

    useEffect(() => {

        updateMaxChatBoxes();
        window.addEventListener("resize", updateMaxChatBoxes);
        return () => window.removeEventListener("resize", updateMaxChatBoxes);
    }, []);

  // ChatBox functions    
  const openChatBox = (data) => {
    //check if checkbox is already openend or not 
    if (chatBoxes.some(chat => chat.id === data.supportId)) {
        return;
    }
    setChatBoxes(prev => {
        if (prev.length >= maxChatBoxes) {

            // Create a string pair of supportId and emailId
       
            const newChatBoxes = prev.slice(1); // Remove the oldest chatbox
            return [...newChatBoxes, { id: data.supportId, data }];

        }
        let pair = data.supportId + "," + data.emailId;  // You can use a comma or any delimiter you prefer

        // Set the pair in localStorage
        localStorage.setItem("ChatPair", pair);
        return [...prev, { id: data.supportId, data }];
    });

};

    // Open Video Call
    const openVideoCall = (supportId) => {
        setVideoCalls((prev) => [...prev, { id: supportId }]);
    }

    // Close Chat box
    const closeChatBox = (id) => {
        // Add chatbox to exiting list
        setExitingChatBoxes(prev => [...prev, id]);

        // Remove chatbox after animation
        setTimeout(() => {
            localStorage.removeItem('ChatPair')
            setExitingChatBoxes(prev => prev.filter(chatId => chatId !== id));
            setChatBoxes(prev => prev.filter(chat => chat.id !== id));
        }, 500); // Match the duration of the CSS transition
    };

    // Close Video call
    const closeVideoCall = (supportId) => {
        setVideoCalls((prev) => prev.filter((call) => call.id !== supportId));
    };

    const exportAsExcel = () => {
        const rangeStartDate = rangeStart ? moment(rangeStart.$d).format('MM/DD/YYYY hh:mm:ss A') : null;
        const rangeEndDate = rangeEnd ? moment(rangeEnd.$d).format('MM/DD/YYYY hh:mm:ss A') : null;
        const payload = {
            userId: loggedUserId,
            startDate: rangeStartDate,
            endDate: rangeEndDate
        }
        fetchAllSupportdata(payload)
            .then(response => {
               
                dispatch(getallsupportdata(response.data));
                const assignedData = response.data.data.assignedData || [];
                const acknowledgeData = response.data.data.acknowledgeData || [];
                const closedData = response.data.data.closedData || [];

                const todayDate = new Date();
                todayDate.setHours(todayDate.getHours() - 5);
                const formattedDate = `${todayDate.getDate()}/${todayDate.getMonth() + 1}/${todayDate.getFullYear()}`;
                const formattedDateTime = `${todayDate.getDate()}/${todayDate.getMonth() + 1}/${todayDate.getFullYear()} ${todayDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

                let assignedColumns = [
                    "Sr. No.",
                    "Support Id",
                    "Company",
                    "Site",
                    "App",
                    "Description",
                    "Requested By",
                    "Request Date",
                    "Communicate By",
                    "Priority",
                    "Assigned To",
                    "Assigned Date"
                ];

                let acknowledgeColumns = [
                    ...assignedColumns,
                    "Start Date",
                    "Status",
                    "Note",
                ];

                let closedColumns = [
                    ...assignedColumns,
                    "Start Date",
                    "Status",
                    "Closed Date"
                ];

                let combinedData = [
                    [],
                    [`Project: TEKaVerse`],
                    [`Extracted Date:`, ` ${formattedDateTime}`, "", "", "", "", "", "", "", "Powered By : AuthenTEK"],
                    [`Date Range :  ${rangeStartDate != null && rangeEndDate != null ? rangeStartDate + " To " + rangeEndDate : rangeStartDate != null ? rangeStartDate : ""}`],

                    [], []
                ];

                const generateRows = (data, columns) => {
                    return data.map((item, index) => {
                        const rowData = columns.map(column => {
                            switch (column) {
                                case "Sr. No.":
                                    return index + 1;
                                case "Support Id":
                                    return item.supportId || "";
                                case "Company":
                                    return item.companyName || "";
                                case "Site":
                                    return item.siteName || "";
                                case "App":
                                    return item.appName || "";
                                case "Description":
                                    return item.description || "";
                                case "Requested By":
                                    return item.requestedBy || item.desktopName || "";
                                case "Request Date":
                                    return item.requestDate || "";
                                case "Communicate By":
                                    return item.phoneNumber === "null" ? "" : item.phoneNumber || "";
                                case "Priority":
                                    return item.priority === 0 ? "High" : item.priority === 1 ? "Medium" : "Low";
                                case "Assigned To":
                                    return item.assignedName || "";
                                case "Assigned Date":
                                    return item.assignedDate || "";
                                case "Start Date":
                                    return item.startDate || "";
                                case "Note":
                                    return item.actionTaken || "";
                                case "Status":
                                    return item.status === 0 ? 'Active' : item.status === 1 ? 'Pending' : item.status === 2 ? 'Working' : item.status === 3 ? 'Closed' : "";
                                case "Closed Date":
                                    return item.closedDate || "";
                                default:
                                    return "";
                            }
                        });
                        return rowData;
                    });
                };

                const addSection = (title, columns, data) => {
                    combinedData.push(
                        [], // Adding an empty row for spacing
                        [title],
                        columns,
                        ...(data.length > 0 ? generateRows(data, columns) : new Array(1).fill(columns.map(() => ""))) // Add empty rows if no data
                    );
                };

                addSection("Assigned Support Requests", assignedColumns, assignedData);
                addSection("On Process Support Requests", acknowledgeColumns, acknowledgeData);
                addSection("Closed Support Requests", closedColumns, closedData);

                const currentDate = new Date();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const year = currentDate.getFullYear();
                const hours = String(currentDate.getHours()).padStart(2, '0');
                const minutes = String(currentDate.getMinutes()).padStart(2, '0');

                let wb = utils.book_new();
                let ws = utils.json_to_sheet(combinedData, { blankrows: 3 });

                ws['!cols'] = [];
                const defaultColWidth = { wpx: 80 };
                assignedColumns.forEach((col, index) => {
                    if (index < 1) {
                        ws['!cols'].push(defaultColWidth);
                    } else if (index === 1 || index === 7) {
                        ws['!cols'].push({ wpx: 120 });
                    } else if (index === 11 || index === 12 || index === 14) {
                        ws['!cols'].push({ wpx: 160 });
                    } else {
                        ws['!cols'].push({ wpx: 80 });
                    }
                });

                utils.book_append_sheet(wb, ws, `Support Request List`);
                const downloadFileName = `Support_Requests_${year}${month}${day}_${hours}${minutes}.xlsx`;

                writeFile(wb, downloadFileName);
            })
            .catch((err) => {
                console.log("Error exporting data to Excel:", err);
            });
    };

    const getSupportDetails = () => {
        setLoading(true)
        const rangeStartDate = rangeStart ? moment(rangeStart.$d).format('MM/DD/YYYY hh:mm:ss A') : null;
        const rangeEndDate = rangeEnd ? moment(rangeEnd.$d).format('MM/DD/YYYY hh:mm:ss A') : null;
        const payload = {
            userId: loggedUserId,
            startDate: rangeStartDate,
            endDate: rangeEndDate
        }
        fetchAllSupportdata(payload)
            .then(response => {
               
                dispatch(getallsupportdata(response.data))
                setAssignedTable(response.data.data.assignedData)
                setNewSupportCount(response.data.data.assignedData.length)
                setAcknowledgedTable(response.data.data.acknowledgeData)
                setClosedTable(response.data.data.closedData)
                setOptions({
                    ...options,
                    pagination: {
                        ...options.pagination,
                        total: response.data.data.newRequestCount,
                    },
                });
                setAssignedOptions({
                    ...assignedoptions,
                    pagination: {
                        ...assignedoptions.pagination,
                        total: response.data.data.assignedCount,
                    },
                });

                setAcknowledgedOptions({
                    ...acknowledgedoptions,
                    pagination: {
                        ...acknowledgedoptions.pagination,
                        total: response.data.data.acknowledgedCount,
                    },
                });

                setClosedOptions({
                    ...closedoptions,
                    pagination: {
                        ...closedoptions.pagination,
                        total: response.data.data.closedCount,
                    },
                });

                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }

    const onDownloadButtonClick = (data) => {
        const url = data;

        const filename = data.substring(data.lastIndexOf('/') + 1);
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                saveAs(blob, filename);
            })
            .catch((error) => {
                console.log("Download error:", error);
            });
    };

    const handleSearchRequest = () => {
        if (rangeStart && !rangeEnd) {
            toast.error(t("PleaseentertheEndDate"), {
                autoClose: 8000,
            });
            return;
        }
        if (!rangeStart && rangeEnd) {
            toast.error(t("PleaseenterthestartDate"), {
                autoClose: 8000,
            });
            return;
        }
        if (rangeEnd < rangeStart) {
            toast.error(t("EnddateshouldnotbelessthanStartdate"), {
                autoClose: 8000,
            });
            return;
        };
        setResetDisplay(true);
        getSupportDetails()
    }

    const handleResetSearch = () => {

        setRangeStart(null)
        setRangeEnd(null)
        setResetDisplay(false);
    }

    const getRoleDetails = () => {
        fetchUserRoledata(loggedUserId)
            .then(response => {
                dispatch(getuserroleandmenu(response.data))
                if (response.data.data.userRoleDetails[0].roleName)
                    setRoleName(response.data.data.userRoleDetails[0].roleName);
                setRoleId(response.data.data.userRoleDetails[0].roleId);
               
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const getworkitemsupportdetails = () => {
        setLoading(true)
        fetchWorkItemswithsupport()
            .then(response => {
                dispatch(getworkitemsupportdata(response.data))
                setSupportData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }

    const getallusersdata = () => {
        setLoading(true)
        fetchUsersFromNotification()
            .then(response => {
                dispatch(getuserslistfromnotification(response.data))
                setAllUserData(response.data.data)
                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const getallusershavingsupportaccess = () => {
        setLoading(true)
        fetchusersupportaccessdata()
            .then(response => {

                setAllUserSupportData(response.data.data)
                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const supportUser = allUserData && allUserData.includes(parseInt(loggedUserId));

    const getallusersbygroupid = (sitename) => {

        setLoading(true)
        fetchUsersByGroupId(sitename)
            .then(response => {

                setCallOrderData(response.data.data)
                setLoading(false)

            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleAssignedChange = (pagination, sorter, current) => {
        const updatedOptions = { ...assignedoptions, pagination };
        setAssignedOptions(updatedOptions);
        setPageData(updatedOptions)
    };

    const handleAcknowledgedChange = (pagination, sorter, current) => {
        const updatedOptions = { ...acknowledgedoptions, pagination };
        setAcknowledgedOptions(updatedOptions);
        setPageData(updatedOptions)

    };

    const handleClosedChange = (pagination, sorter, current) => {
        const updatedOptions = { ...closedoptions, pagination };
        setClosedOptions(updatedOptions);
        setPageData(updatedOptions)

    };

    const playAudio = (source) => {


        const sound = new Howl({
            src: [source]
        });
        sound.play();
    };

    const handleSupportChange = (id, compid, siteid) => {
        const url = `/Workitem/Create/Support/${id}/${compid}/${siteid}`;
        // window.location.href = url;
        history.push(url);
    };

    const opensupportreport = () => {
        // window.location.href = "/SupportReport";
        history.push("/SupportReport");
    };

    const openloadreport = () => {
        getworkitemsupportdetails();
        getSupportDetails();
    }

    const openWorkitemEdit = (id, supportid) => {
        // window.location.href = `/Workitem/Edit/${id}/${supportid}`;
        history.push(`/Workitem/Edit/${id}/${supportid}`);
    };

    //const openWorkitemEdit = (id, supportid) => {
    //    window.location.href = "/Workitem/Edit/" + id;
    //};

    const handleImageClick = (supportAttachments) => {
        setAttachmentSrc(supportAttachments);
        setSupportAttachmentModal(true);
    };

    const handleCarouselImageClick = (attachmentTypeId) => {
        setAttachmentType(attachmentTypeId);
        setShowCarouselModal(true);
    };

    const handleAddSupportClick = () => {
        setShowAddSupport(true)
        setShowSupportModal(true);
        // getallcompaniesdata();
    };

    const handleCarouselModalClose = () => {
        setCurrentIndex(0);
        setShowCarouselModal(false);
    };

    const handleModalClose = () => {
        setSupportAttachmentModal(false);
    };

    const Prioritydata = [
        {
            key: '1',
            id: 1,
            name: 'High',
        },
        {
            key: '2',
            id: 2,
            name: 'Medium',
        },

        {
            key: '3',
            id: 3,
            name: 'Low',
        },

    ];

    const Statusdata = [
        {
            key: '0',
            id: 0,
            name: 'Active',


        },
        {
            key: '1',
            id: 1,
            name: 'Pending',


        },

        {
            key: '2',
            id: 2,
            name: 'Working',
        },

        {
            key: '3',
            id: 3,
            name: 'Closed',
        },

    ];

    const UpdateUserManually = async () => {

        const formData = new FormData();
        formData.append("SupportId", comingsupportId);
        formData.append("UserId", supportuserId);
        setLoading(true)
        const response_ = await axios({
            method: 'post',
            url: url.ASSIGN_USERMANUALLY,
            data: formData,
        }).then(response => {

            if (response.data.success) {
                toast.success("User Updated Successfully", {
                    className: "toastSuccess",
                });

                setIsDrawerOpen(false)
                setSupportUserId()
                setEditable(false)
                setEditableRow(false)
                getSupportDetails();

            } else {
                toast.error(`${response.data.message}`, {
                    className: "toastError",
                });

            }
            setLoading(false)
        })

    }

    const UpdatePriority = async (id) => {
        setLoading(true)
        const selectedPriorityIndex = priorityindex;
        const selectedPriorityValue = priorities[selectedPriorityIndex];
        const selectedCallOrderIndex = callOrderIndex;
        const selectedCallOrderValue = callOrder[callOrderIndex];

        const formData = new FormData();
        formData.append("Priority", selectedPriorityValue != undefined ? selectedPriorityValue : "");
        formData.append("CallOrderUserId", userId != undefined ? userId : "")
        formData.append("SupportId", id);
        const response_ = await axios({
            method: 'post',
            url: url.UPDATE_PRIORITY,
            data: formData,
        }).then(response => {
            if (response.data.success == false) {

                toast.error(t("Invaliduser"), {
                    className: "toastSuccess",
                });
            }
            else {
                dispatch(updateprioritydata(response.data))
                toast.success(t("SupportDataAdded"), {
                    className: "toastSuccess",
                });
                setApplyModal(false)
                setNewSupportCount(prevCount => prevCount - 1)
                setEditable(false)
                setIsPriority(false)
                getSupportDetails();
            }
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setLoading(false)

    }

    const UpdateAssignedData = async (id) => {
        setLoading(true)
        const formData = new FormData();
        formData.append("SupportId", id);
        const response_ = await axios({
            method: 'post',
            url: url.UPDATE_ASSIGNEDDATA,
            data: formData,
        }).then(response => {
            if (response.data.success == false) {

                toast.error(t("Invaliduser"), {
                    className: "toastSuccess",
                });
            }
            else {
                dispatch(updateassigneddetails(response.data))
                toast.success(t("AcknowledgeUpdated"), {
                    className: "toastSuccess",
                });
                getSupportDetails();
                setAcknowledgeModal(false)

            }
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setLoading(false)

    }

    const UpdateStatusData = async (id) => {
        setLoading(true)

        const selectedStatusIndex = statusindex;
        const selectedStatusValue = statusnew[selectedStatusIndex];
        const formData = new FormData();
        formData.append("SupportId", id);
        formData.append("Status", selectedStatusValue == undefined ? 4 : selectedStatusValue);
        formData.append("ActionTaken", actiontaken);

        const response_ = await axios({
            method: 'post',
            url: url.UPDATE_STATUSDATA,
            data: formData,
        }).then(response => {
            if (response.data.success == false) {
                toast.error(t("Invaliduser"), {
                    className: "toastSuccess",
                });
            }
            else {
                dispatch(updatestatusdetails(response.data))
                toast.success(t("StatusUpdated"), {
                    className: "toastSuccess",
                });

                setUpdateModal(false)
                setStatusNew({})
                getSupportDetails();
            }
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setLoading(false)

    }

    const [priorities, setPriorities] = useState({});

    const handlePriorityChange = (value, index) => {
        // setIsPriority(true)
        setPriorities(prevState => ({
            ...prevState,
            [index]: value
        }));

        setIsPriority(prevState => ({
            ...prevState,
            [index]: true
        }));
    };

    const [callOrder, setCallOrder] = useState({});

    const handleCallOrderChange = (value, index) => {

        setCallOrder(prevState => ({
            ...prevState,
            [index]: value
        }));
        setFilteredOptions([])
    };

    const [statusnew, setStatusNew] = useState({});

    const handleStatusChange = (value, index) => {
        setStatusNew(prevState => ({
            ...prevState,
            [index]: value
        }));
    };

    const handleInputForDropdown = (input) => {

        const filtered = callOrderData && callOrderData.filter(item => {
            const fullName = item.userName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredOptions(filtered);
    };

    const handleAssignedUserClick = (user) => {

        setComingSupportId(user.supportId)
        getallusershavingsupportaccess();
        setIsDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setAllUserSupportData([]);
        setIsDrawerOpen(false);
        setSupportUserId()
    };

    const handleEdit = (Id, sitename) => {
        setEditable(true)
        setEditableRow(Id);
        getallusersbygroupid(sitename)
    }

    const handleSupportLog = (supportId) => {
        history.push(`/LogDetails/${supportId}`);
        // console.log("hello")
    }

    const assignedcolumns = [
        {
            title: t("RequestID"),
            dataIndex: "supportId",
        },

        {
            title: t("Company"),
            dataIndex: "companyName",
            render: (text, record, index) => (
                <>
                    {record.companyName !== null && record.companyName !== "" ? (
                        record.companyName
                    ) : (
                        <div>
                            <a
                                href={`/Site/edit/${encodeURIComponent(record.siteId)}`}
                            // target="_blank" // Opens in a new tab
                            >
                                <span className="noAssignedName">{t("Notassigned")}</span>
                            </a>
                        </div>
                    )}
                </>
            )
        },

        {
            title: t("Site"),
            dataIndex: "siteName",
        },

        {
            title: t("App"),
            dataIndex: "appName",
        },

        {
            title: t("RequestType"),
            dataIndex: "RequestType",
            render: (value, item, index) =>
            (<>
                {
                    (<>
                        {item.requestType === 1 &&
                            <div className="centered-container  position-relative   ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>
                                    <button className="request-button-css"
                                        // disabled={item.assignedDate === null || item.requestedBy === loginUserName}
                                        // onClick={() => {
                                        //     setAudioCallContent(item);
                                        //     setAudioCallInitiated(true);
                                        // }} 
                                        disabled
                                    >

                                        <img src={call_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                        {item.requestType === 0 &&
                            <div className="centered-container ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>
                                    <button className="request-button-css"
                                        // disabled={item.assignedDate === null || item.requestedBy === loginUserName}
                                        // onClick={() => {
                                        //     setSelectedChatContent(item);
                                        //     openChatBox(item);
                                        // }} 
                                        disabled
                                    >
                                        <img src={chat_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>}

                        {item.requestType === 2 &&
                            <div className="centered-container ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>
                                    <button className="request-button-css"
                                        // disabled={item.assignedDate === null || item.assignedName !== currentUserName}
                                        // onClick={() => {
                                        //     if (item.assignedDate !== null && item.assignedName === currentUserName && item.requestedBy !== currentUserName) {
                                        //         handleVideo(item)
                                        //     }
                                        //     if (item.requestedBy === currentUserName) {
                                        //         toast.error("Self call is not allowed")
                                        //     }
                                        // }}
                                        disabled
                                    >
                                        <img src={video_call} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 3 &&
                            <div className="centered-container ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>

                                    <a href={`mailto:${item.emailId}`}
                                        //   style={{ textDecoration: "none", color: "inherit" }}
                                        className="request-button-css"
                                        //  disabled={item.assignedDate === null || item.requestedBy === loginUserName}
                                        disabled
                                    >
                                        <img src={email_icon} className="apply-img"
                                        ></img>
                                    </a>
                                </Tooltip>
                            </div>
                        }

                        {item.requestType === 4 &&
                            <div className="centered-container ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>
                                    <button className="request-button-css"
                                        // disabled={item.assignedDate === null || item.requestedBy === loginUserName}
                                        // onClick={() => {
                                        //     setSelectedChatContent(item);
                                        //     openChatBox(item);
                                        //     console.log("Whatsapp functionality yet to implement")
                                        // }}
                                        disabled >
                                        <img src={whatsapp} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                        {item.requestType === 5 &&
                            <div className="centered-container ">
                                <Tooltip title={t("AcknowledgeThisRequestFirst")}>
                                    <button className="request-button-css"
                                        // disabled={item.assignedDate === null || item.requestedBy === loginUserName}
                                        // onClick={() => {
                                        //     setSelectedChatContent(item);
                                        //     openChatBox(item);
                                        //     console.log("SMS functionality yet to implement")
                                        // }} 
                                        disabled
                                    >
                                        <img src={SMS} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                    </>)
                }
            </>)
        },



        {
            title: t("Description"),
            dataIndex: "description",
            className: "description_support",
            render: (description) => <Tooltip title={description}>{description}</Tooltip>,
        },

        {
            title: t("Preview"),
            render: (record) => {
                return (
                    record.supportAttachments.length > 0 && (
                        <Tooltip title={t("Preview")}>
                            <AttachmentIcon onClick={() => handleImageClick(record.supportAttachments)} style={{ color: '#fbaf5d', height: '30px', width: '30px', cursor: 'pointer' }} fontSize="medium" />
                        </Tooltip>
                    )
                );
            }
        },

        {
            title: t("RequestedBy"),
            dataIndex: "requestedBy",
            className: "name-wrap"
        },

        {
            title: t("RequestDate"),
            dataIndex: "requestDate",
            className: "date-wrap",
            // render: (requestDate) => getFullDate(requestDate),
        },

        {
            title: "Communicate By",
            dataIndex: "phoneNumber",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {(record.requestType === 1 || record.requestType === 4 || record.requestType === 5) ?
                    <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">{record.phoneNumber}</div>
                    : (
                        record.emailId != "null" ? (
                            <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">
                                {record.emailId}
                            </div>
                        ) : ""
                    )}
            </>)
        },

        ...(userRole && userRole == "SuperAdmin" ?
            [
                {
                    title: t("Priority"),
                    // key: 'i',           
                    render: (record, row, i) => (
                        <div key={record.supportId} className='d-flex'>

                            <Select
                                aria-label=".form-select-lg example"
                                style={{ width: 110 }}
                                placeholder={t("Priority")}
                                id={i + 1}
                                key={row.supportId}
                                value={priorities[i]}
                                defaultValue={record.priority}
                                onChange={(value) => handlePriorityChange(value, i)}
                            >
                                {
                                    Prioritydata && Prioritydata.map((data, k) => (
                                        <Option key={data.id} value={data.id}>
                                            {data.name}
                                        </Option>)
                                    )}
                            </Select>
                        </div>
                    )
                },
            ] :
            [
                {
                    title: t("Priority"),
                    dataIndex: "priority",
                    render: (value, item, index) =>
                    (<>
                        {item.priority == 1 ?
                            <div>
                                <span>High</span>
                            </div> :
                            item.priority == 2 ?
                                <div>
                                    <span>Medium</span>
                                </div> :
                                <div>
                                    <span>Low</span>
                                </div>
                        }
                    </>)
                },
            ]
        ),

        {
            title: t("Technician"),
            dataIndex: "",
            render: (text, record, index) =>
            (<>
                {editable && editableRow === record.supportId ?
                    <div key={record.supportId} className='d-flex align-items-center'>

                        <Select className=""
                            aria-label=".form-select-lg example"
                            placeholder="Select User"
                            showSearch
                            defaultValue={record.assignedName}
                            onChange={(value) => {
                                setUserId(value)
                            }}
                            onSearch={(value) => {
                                handleInputForDropdown(value)
                            }}
                            filterOption={false}
                            style={{ width: 150 }}
                        >
                            {filteredOptions.length > 0 ?
                                filteredOptions && filteredOptions.map(item =>
                                    <Option key={item.userId} value={item.userId}>
                                        {item.userName}
                                    </Option>
                                )
                                :
                                callOrderData && callOrderData.map(item =>
                                    <Option key={item.userId} value={item.userId}>
                                        {item.userName}
                                    </Option>
                                )
                            }
                        </Select>

                        <div className="ml-2">
                            {userRole && userRole === "SuperAdmin" && (
                                <Tooltip title={t("ClicktoAssignUser")}>
                                    <a className="btn btn-primary usersupportgrp-btn" onClick={() => handleAssignedUserClick(record)}>
                                        <GroupAddIcon style={{ fontSize: '16px' }} />
                                    </a>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    :
                    <label>{record.assignedName}</label>
                }
            </>
            )
        },

        {
            title: t("AssignedDate"),
            dataIndex: "assignedDate",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {record.assignedDate && record.userId > 0 ? record.assignedDate :
                    <div>
                        <span className="noAssignedName">{t("Pleaseassignagroup")}</span>
                        {userRole && userRole === "SuperAdmin" ?
                            <Tooltip title={t("ClicktoReviewCalendar")}>
                                <a
                                    className="btn btn-primary supportgrp-btn m-2"
                                    href={`/SupportTechnician?groupId=${encodeURIComponent(record.supportGroupId)}&supportId=${encodeURIComponent(record.supportId)}&siteId=${encodeURIComponent(record.siteId)}`}
                                //target="_blank"
                                >
                                    <CalendarMonthIcon style={{ fontSize: '18px' }} />
                                </a>

                            </Tooltip>
                            : ""
                        }

                        {userRole && userRole === "SuperAdmin" ?
                            <Tooltip title={t("ClicktoAssignUser")}>
                                <a
                                    className="btn btn-primary supportgrp-btn m-2"

                                >
                                    <GroupAddIcon style={{ fontSize: '18px' }}
                                        onClick={() => handleAssignedUserClick(record)}
                                    />
                                </a>

                            </Tooltip>
                            : ""
                        }
                    </div>

                }
            </>
            )
        },


        {
            title: t("Assign"),
            key: 'index',


            render: (text, record, index) => (<>
                {(userRole && userRole === "SuperAdmin") && (
                    record.assignedName !== null && (
                        (editable && editableRow === record.supportId) || ispriority[index] ?

                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <Tooltip title={t("Clicktoassign")}>
                                    <button
                                        className="assign-btn btn btn-primary px-2 py-1"
                                        id={index + 1}
                                    >
                                        <img src={ApplyIcon} onClick={() => handleApply(record.supportId, index)} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div> :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <Tooltip title={t("ClicktoChangeTechnician")}>
                                    <button
                                        className="assign-btn btn btn-primary px-2 py-1"
                                        id={index + 1}
                                    >
                                        <img src={Edit_light} onClick={() => handleEdit(record.supportId, record.siteName)} className="edit-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>
                    )
                )}

            </>)
        },




        {
            title: t("DoAcknowledge"),
            key: 'index',
            render: (text, record, index) => {
                const shouldShowButton = record.assignedName !== null && userRole && userRole === "SuperAdmin" ||
                    (record.assignedName !== null  && userRole && userRole === "Admin")
                    || (record.assignedName !== null && record.allowMaintenance === true)
                    || record.userId == loggedUserId;

                return shouldShowButton ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Tooltip title={t("Clicktoacknowledge")}>
                            <button className="acknowledge-btn btn btn-primary px-2 py-1" id={index + 1}>
                                <img
                                    src={AcknowledgeIcon}
                                    onClick={(e) => handleAcknowledge(record.supportId)}
                                    className="apply-img"
                                    alt="Acknowledge"
                                />
                            </button>
                        </Tooltip>
                    </div>
                ) : null;
            }
        },




        // {
        //     title: t("Log"),
        //     render: (record, index) => (<>
        //         {record.supportId !== null && record.assignedDate != null ? (
        //             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        //                 <Tooltip title={t("ClicktoviewLog")}>
        //                     <button className="acknowledge-btn btn btn-primary px-2 py-1" onClick={(e) => handleSupportLog(record.supportId)}>
        //                         <img style={{ filter: "invert(0) brightness(2)" }} src={LogIcon} alt="LogDetails" /></button>
        //                 </Tooltip>
        //             </div>

        //         ) : ''}
        //     </>)
        // }


        {
            title: t("Action"),
            dataIndex: "",
            render: (record, index) => (
                <Dropdown className="action-dropdown"
                    overlay={
                        <Menu className="flex-box-inner">
                            <Menu.Item key="ClicktoviewLog" onClick={(e) => handleSupportLog(record.supportId)}>
                                <button className="table-btn" >
                                    <img src={LogIcon} alt="LogDetails" width={20} height={20} /></button>
                                {t("Log")}
                            </Menu.Item>
                            {userRole && userRole === "SuperAdmin" ?
                                <Menu.Item key="delete" onClick={(e) => handleDeleteSupportItem(record.supportId)}>
                                    <button className="table-btn" >
                                        <img src={Trash_light} alt="LogDetails" width={20} height={20} /></button>
                                    {t("Delete")}
                                </Menu.Item> : ""
                            }
                        </Menu>
                    }
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <a className="ant-dropdown-link d-flex justify-content-between align-items-center" onClick={e => e.preventDefault()}>
                        <span>{t("Actions")} </span>
                        {/*<DownOutlined style={{ fontSize: '8px' }}*/}
                        {/*/>*/}
                    </a>
                </Dropdown>
            )
        },


    ]
    const { confirm } = Confirm;
    const handleDeleteSupportItem = (supportId) => {
        confirm({
            title: t('ConfirmRemoveSupportItem'),
            okText: t('Yes'),
            okType: 'danger',
            cancelText: t('No'),
            onOk() {
                DeleteSupportItem(supportId)
            },
            onCancel() {
            },
        });
    }
    const DeleteSupportItem = (Id) => {
        debugger
        setLoading(true)
        axios.put(url.DELETE_SUPPORTITEM + '/' + Id, {
        }).then(response => {
            if (response.data.success == false) {
                toast.error(t("NoSupportItemDeleted"), {
                    className: "toastSuccess",
                });
            }
            else {
                setLoading(true)
                getSupportDetails();
                toast.success(t("SupportItemDeletedSuccess"), {
                    className: "toastSuccess",
                });
            }

        }).catch((err) => {
            console.log("Err: ", err);
        });
        setLoading(false);
    }

    const handleActionChange = (value, index) => {
        const newData = [...acknowledgedtable];
        newData[index].actionTaken = value;
        setAcknowledgedTable(newData);
        setActionTaken(newData[index].actionTaken)
    };

    const handleApply = (supportId, index) => {

        const selectedPriority = priorities[index];
        // const selectedCallOrder = callOrder[index];
        if (selectedPriority == undefined && userId == null && userId == undefined) {
            toast.error(t("PleaseUpdatePriorityorTechnician"), {
                className: "toastSuccess",
            });
            return;
        }
        setApplyId(supportId)
        setPriorityIndex(index)
        // setCallOrderIndex(index)
        setApplyModal(true);
    };

    const handleUpdate = (supportId, index, record) => {
        setSupportId(supportId)
        setStatusIndex(index)
        setUpdateModal(true);

        //const selectedStatus = statusnew[index];
        //if (selectedStatus == undefined) {
        //    toast.error(t("PleaseUpdateStatus"), {
        //        className: "toastSuccess",
        //    });
        //}
        //else {
        //    setSupportId(supportId)
        //    setStatusIndex(index)
        //    setUpdateModal(true);
        //}
    };

    const handleAcknowledge = (id) => {
        setAcknowledgeId(id)
        setAcknowledgeModal(true);
    };

    const handleUpdateModalClose = () => {
        setUpdateModal(false);
    };

    const handleApplyModalClose = () => {
        setApplyModal(false);
    };

    const handleShowModalClose = () => {
        setShowAddSupport(false)
        //  setResetDisplay(true)
    };

    const handleAcknowledgeModalClose = () => {
        setAcknowledgeModal(false);
    };

    const isImage = (attachments) => {
        if (!Array.isArray(attachments) || attachments.length === 0) return false; // Return false if attachments is not an array or empty
        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];
        for (let attachment of attachments) {
            if (!attachment.source) continue; // Skip if source is null or undefined
            const extension = attachment.source.substring(attachment.source.lastIndexOf("."));
            if (imageExtensions.includes(extension.toLowerCase())) {
                return true; // Return true if any attachment is an image
            }
        }
        return false; // Return false if none of the attachments are images
    };

    const isDocument = (attachments) => {
        if (!Array.isArray(attachments) || attachments.length === 0) return false; // Return false if attachments is not an array or empty
        const documentExtensions = [".pdf"];
        for (let attachment of attachments) {
            if (!attachment.source) continue; // Skip if source is null or undefined
            const extension = attachment.source.substring(attachment.source.lastIndexOf("."));
            if (documentExtensions.includes(extension.toLowerCase())) {
                return true; // Return true if any attachment is a document
            }
        }
        return false; // Return false if none of the attachments are documents
    };

    const isAudio = (attachments) => {
        if (!Array.isArray(attachments) || attachments.length === 0) return false; // Return false if attachments is not an array or empty
        const audioExtensions = [".mp3", ".wav", ".ogg", ".webm"]; // Add more audio extensions as needed
        for (let attachment of attachments) {
            if (!attachment.source) continue; // Skip if source is null or undefined
            const extension = attachment.source.substring(attachment.source.lastIndexOf("."));
            if (audioExtensions.includes(extension.toLowerCase())) {
                return true; // Return true if any attachment is an audio file
            }
        }
        return false; // Return false if none of the attachments are audio files
    };

    const isVideo = (attachments) => {
        if (!Array.isArray(attachments) || attachments.length === 0) return false; // Return false if attachments is not an array or empty
        const videoExtensions = [".mp4", ".avi", ".mov", ".mkv", ".wmv"]; // Add more video extensions as needed
        for (let attachment of attachments) {
            if (!attachment.source) continue; // Skip if source is null or undefined
            const extension = attachment.source.substring(attachment.source.lastIndexOf("."));
            if (videoExtensions.includes(extension.toLowerCase())) {
                return true; // Return true if any attachment is a video file
            }
        }
        return false; // Return false if none of the attachments are video files
    };

    const acknowledgedcolumns = [
        {
            title: t("RequestID"),
            dataIndex: "supportId"
        },

        {
            title: t("SupportId"),
            key: 'i',
            render: (record, row, i) => {
                const foundSupportData = supportData.find(item => item.supportId === row.supportId);

                if (!foundSupportData) return null;

                return (
                    <div
                        className="sup-workItem-container"
                        onClick={() => openWorkitemEdit(foundSupportData.workItemId, record.supportId)}
                    >
                        <span className="sup-workItem-highlight">
                            {foundSupportData?.workTypeId === 3 ? `#${foundSupportData.workItemId}` : ""}
                        </span>
                    </div>
                );
            }
        },

        {
            title: t("Company"),
            dataIndex: "companyName",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {record.companyName !== null && record.companyName !== "" ? (
                    record.companyName
                ) : (
                    <div>
                        <a
                            href={`/Site/edit/${encodeURIComponent(record.siteId)}`}
                        // target="_blank" // Opens in a new tab
                        >
                            <span className="noAssignedName">{t("Notassigned")}</span>
                        </a>
                    </div>
                )}
            </>
            )
        },

        {
            title: t("Site"),
            dataIndex: "siteName",
        },

        {
            title: t("App"),
            dataIndex: "appName",
        },

        {
            title: t("RequestType"),
            dataIndex: "RequestType",
            render: (value, item, index) =>
            (<>
                {
                    (<>
                        {item.requestType === 1 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Audio call") : t("RequestforAudiocall")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setAudioCallContent(item);
                                            setAudioCallInitiated(true);
                                        }} >
                                        <img src={call_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>}

                        {item.requestType === 0 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Live Chat") : t("RequestforLiveChat")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                        }} >
                                        <img src={chat_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>}

                        {item.requestType === 2 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate video call") : t("RequestforVideoCall")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            handleVideo(item)
                                        }}
                                    >
                                        <img src={video_call} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 3 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Email") : t("RequestforEmail")}>
                                    <a href={`mailto:${item.emailId}`}
                                        //   style={{ textDecoration: "none", color: "inherit" }}
                                        className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                    >
                                        <img src={email_icon} className="apply-img"
                                        ></img>
                                    </a>
                                </Tooltip>
                            </div>
                        }

                        {item.requestType === 4 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Whatsapp chat") : t("RequestforWhatsapp")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                            console.log("Whatsapp functionality yet to implement")
                                        }} >
                                        <img src={whatsapp} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                        {item.requestType === 5 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate SMS") : t("RequestforSMS")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                        }} >
                                        <img src={SMS} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                    </>)
                }
            </>)
        },
        
        {
            title: t("Description"),
            dataIndex: "description",
            className: "description_support",
            render: (description) => <Tooltip title={description}>{description}</Tooltip>,
        },

        {
            title: t("Preview"),
            render: (record) => {
                return (
                    record.supportAttachments.length > 0 && (
                        <Tooltip title={t("Preview")}>
                            <AttachmentIcon onClick={() => handleImageClick(record.supportAttachments)} style={{ color: '#fbaf5d', height: '30px', width: '30px', cursor: 'pointer' }} fontSize="medium" />
                        </Tooltip>
                    )
                );
            }
        },

        {
            title: t("RequestedBy"),
            dataIndex: "requestedBy",
            className: "name-wrap"
        },

        {
            title: t("RequestDate"),
            dataIndex: "requestDate",
            className: "date-wrap",

        },

        {
            title: "Communicate By",
            dataIndex: "phoneNumber",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {(record.requestType === 1 || record.requestType === 4 || record.requestType === 5) ?
                    <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">{record.phoneNumber}</div>
                    : (
                        record.emailId != "null" ? (
                            <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">
                                {record.emailId}
                            </div>
                        ) : ""
                    )}
            </>)
        },

        {
            title: t("Priority"),
            dataIndex: "priority",
            render: (value, item, index) =>
            (<>
                {item.priority == 1 ?
                    <div>
                        <span>High</span>
                    </div> :
                    item.priority == 2 ?
                        <div>
                            <span>Medium</span>
                        </div> :
                        <div>
                            <span>Low</span>
                        </div>
                }
            </>)
        },

        {
            title: t("AssignedTo"),
            dataIndex: "assignedName",
            className: "name-wrap"

        },

        {
            title: t("AssignedDate"),
            dataIndex: "assignedDate",
            className: "date-wrap",


        },

        {
            title: t("StartDate"),
            dataIndex: "startDate",
            className: "date-wrap",
        },

        {
            title: t("Note"),
            // dataIndex: "actionTaken",
            key: 'i',
            render: (text, record, index) => (
                <TextArea
                    value={text.actionTaken}
                    onChange={(e) => handleActionChange(e.target.value, index)}
                    style={{ width: '250px' }}
                />
            ),
        },

        {
            title: t("SupportCase"),
            key: 'i',
            render: (record, row, i) => {
                const foundSupportData = supportData && supportData.find(item => item.supportId === row.supportId);
                return (
                    <div className='d-flex'>
                        {foundSupportData ? (
                            // Render text if supportId matches
                            <button className="activeSupportItem" onClick={() => openWorkitemEdit(foundSupportData.workItemId, record.supportId)}>
                                {foundSupportData.workStatus === 1 ? 'Active' :
                                    foundSupportData.workStatus === 2 ? 'Resolved' :
                                        foundSupportData.workStatus === 4 ? 'Testing' :
                                            foundSupportData.workStatus === 5 ? 'Closed' :
                                                //foundSupportData.workTypeId === 0 ? 'Report Bug Added' :
                                                //    foundSupportData.workTypeId === 1 ? 'Feature Request Added' :
                                                foundSupportData.workTypeId === 3 ? t('SupportRequestAdded') :
                                                    ''}
                            </button>
                        ) : (

                            <button className="support-btn btn btn-primary"
                                id={i + 1}
                                onClick={() => handleSupportChange(row.supportId, row.companyId, row.siteId)}
                            >
                                {t("CreateSupportCase")}
                            </button>
                        )}
                    </div>

                )
            }
        },

        {
            title: t("Status"),
            key: 'i',
            render: (record, row, i) => (
                <div className='d-flex'>
                    <Select
                        className="status-support"
                        aria-label=".form-select-lg example"
                        style={{ width: 100 }}
                        placeholder={t("Status")}
                        id={i + 1}
                        key={row.supportId}
                        defaultValue={record.status}
                        // value={statusnew[i]}
                        // onChange={(e) => setStatus(e)}     
                        onChange={(value) => handleStatusChange(value, i)}
                    >

                        {
                            Statusdata && Statusdata.map((data, k) => (
                                <Option key={data.id} value={data.id}>
                                    {data.name}
                                </Option>)

                            )}

                    </Select>
                </div>

            )
        },

        {
            title: t("Update"),
            key: 'index',
            render: (text, record, index) => (<>
                {
                    <Tooltip title={t("Clicktoupdate")}>
                        <button className="acknowledge-btn btn btn-primary px-2 py-1"
                            id={index + 1}
                        >
                            <img src={UpdateIcon}
                                onClick={() => handleUpdate(record.supportId, index, record)}
                                className="apply-img"
                            ></img>
                        </button>
                    </Tooltip>
                }
            </>)
        },

        // {
        //     title: t("Log"),
        //     render: (record, index) => (<>
        //         {record.supportId !== null && record.assignedDate != null ? (
        //             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        //                 <Tooltip title={t("ClicktoviewLog")}>
        //                     <button className="acknowledge-btn btn btn-primary px-2 py-1" onClick={(e) => handleSupportLog(record.supportId)}>
        //                         <img style={{ filter: "invert(0) brightness(2)" }} src={LogIcon} alt="LogDetails" /></button>
        //                 </Tooltip>
        //             </div>

        //         ) : ''}
        //     </>)
        // }
        {
            title: t("Action"),
            dataIndex: "",
            render: (record, index) => (
                <Dropdown className="action-dropdown"
                    overlay={
                        <Menu>
                            <Menu.Item key="ClicktoviewLog" onClick={(e) => handleSupportLog(record.supportId)}>
                                <button className="table-btn" >
                                    <img src={LogIcon} alt="LogDetails" width={20} height={20} /></button>
                                {t("Log")}
                            </Menu.Item>
                            {userRole && userRole === "SuperAdmin" ?
                                <Menu.Item key="delete" onClick={(e) => handleDeleteSupportItem(record.supportId)}>
                                    <button className="table-btn" >
                                        <img src={Trash_light} alt="LogDetails" width={20} height={20} /></button>
                                    {t("Delete")}
                                </Menu.Item> : ""
                            }
                        </Menu>
                    }
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <a className="ant-dropdown-link d-flex justify-content-between align-items-center" onClick={e => e.preventDefault()}>
                        <span>{t("Actions")} </span>
                        {/*<DownOutlined style={{ fontSize: '8px' }}*/}
                        {/*/>*/}
                    </a>
                </Dropdown>
            )
        },
    ]

    const closedcolumns = [
        {
            title: t("RequestID"),
            dataIndex: "supportId",
        },

        {
            title: t("SupportId"),
            key: 'i',
            render: (record, row, i) => {
                const foundSupportData = supportData.find(item => item.supportId === row.supportId);

                if (!foundSupportData) return null;

                return (
                    <div
                        className="sup-workItem-container"
                        onClick={() => openWorkitemEdit(foundSupportData.workItemId, record.supportId)}
                    >
                        <span className="sup-workItem-highlight">
                            {foundSupportData?.workTypeId === 3 ? `#${foundSupportData.workItemId}` : ""}
                        </span>
                    </div>
                );
            }
        },

        {
            title: t("Company"),
            dataIndex: "companyName",
            className: "date-wrap",
            render: (text, record, index) =>
            (
                <>
                    {record.companyName !== null && record.companyName !== "" ? (
                        record.companyName
                    ) : (
                        <div>
                            <a
                                href={`/Site/edit/${encodeURIComponent(record.siteId)}`}
                            //target="_blank" // Opens in a new tab
                            >
                                <span className="noAssignedName">{t("Notassigned")}</span>
                            </a>
                        </div>
                    )}
                </>
            )
        },

        {
            title: t("Site"),
            dataIndex: "siteName",
        },

        {
            title: t("App"),
            dataIndex: "appName",
        },

        {
            title: t("RequestType"),
            dataIndex: "RequestType",
            render: (value, item, index) =>
            (<>
                {
                    (<>
                        {item.requestType === 1 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Audio call") : t("RequestforAudiocall")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setAudioCallContent(item);
                                            setAudioCallInitiated(true);
                                        }} >
                                        <img src={call_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>}

                        {item.requestType === 0 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Live Chat") : t("RequestforLiveChat")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                        }} >
                                        <img src={chat_icon} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>}

                        {item.requestType === 2 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate video call") : t("RequestforVideoCall")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            handleVideo(item)
                                        }}
                                    >
                                        <img src={video_call} className="apply-img"
                                        ></img>
                                    </button>
                                </Tooltip>
                            </div>}

                        {item.requestType === 3 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Email") : t("RequestforEmail")}>
                                    <a href={`mailto:${item.emailId}`}
                                        //   style={{ textDecoration: "none", color: "inherit" }}
                                        className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                    >
                                        <img src={email_icon} className="apply-img"
                                        ></img>
                                    </a>
                                </Tooltip>
                            </div>
                        }

                        {item.requestType === 4 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate Whatsapp chat") : t("RequestforWhatsapp")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                            console.log("Whatsapp functionality yet to implement")
                                        }} >
                                        <img src={whatsapp} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                        {item.requestType === 5 &&
                            <div className="centered-container ">
                                <Tooltip title={item.requestedBy === currentUserName ? t("Only technician can initiate SMS") : t("RequestforSMS")}>
                                    <button className="request-button-css"
                                        disabled={item.assignedDate === null || item.requestedBy === currentUserName}
                                        onClick={() => {
                                            setSelectedChatContent(item);
                                            openChatBox(item);
                                        }} >
                                        <img src={SMS} className="apply-img"
                                        ></img></button></Tooltip>
                            </div>
                        }

                    </>)
                }
            </>)
        },


        {
            title: t("Description"),
            dataIndex: "description",
            className: "description_support",
            render: (description) => <Tooltip title={description}>{description}</Tooltip>,
        },

        {
            title: t("Preview"),
            render: (record) => {
                return (
                    record.supportAttachments.length > 0 && (
                        <Tooltip title={t("Preview")}>
                            <AttachmentIcon onClick={() => handleImageClick(record.supportAttachments)} style={{ color: '#fbaf5d', height: '30px', width: '30px', cursor: 'pointer' }} fontSize="medium" />
                        </Tooltip>
                    )
                );
            }
        },

        {
            title: t("RequestedBy"),
            dataIndex: "requestedBy",
            className: "name-wrap"
        },

        {
            title: t("RequestDate"),
            dataIndex: "requestDate",
            className: "date-wrap",

        },

        {
            title: "Communicate By",
            dataIndex: "phoneNumber",
            className: "date-wrap",
            render: (text, record, index) =>
            (<>
                {(record.requestType === 1 || record.requestType === 4 || record.requestType === 5) ?
                    <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">{record.phoneNumber}</div>
                    : (
                        record.emailId != "null" ? (
                            <div style={{ display: "flex", height: "100%" }} className="activeSupportItem">
                                {record.emailId}
                            </div>
                        ) : ""
                    )}
            </>)
        },

        {
            title: t("Priority"),
            dataIndex: "priority",
            render: (value, item, index) =>
            (<>
                {item.priority == 1 ?
                    <div>
                        <span>High</span>
                    </div> :
                    item.priority == 2 ?
                        <div>
                            <span>Medium</span>
                        </div> :
                        <div>
                            <span>Low</span>
                        </div>
                }
            </>)
        },

        {
            title: t("AssignedTo"),
            dataIndex: "assignedName",
            className: "name-wrap"

        },

        {
            title: t("AssignedDate"),
            dataIndex: "assignedDate",
            className: "date-wrap",


        },

        {
            title: t("StartDate"),
            dataIndex: "startDate",
            className: "date-wrap",
        },

        {
            title: t("Status"),
            dataIndex: "status",
            render: (value, item, index) =>
            (<>
                {item.status == 3 ?
                    <div>
                        <span className="status-resolved">Closed</span>
                    </div> :
                    ""
                }
            </>)
        },

        {
            title: t("ClosedDate"),
            dataIndex: "closedDate",
            className: "date-wrap",

        },

        // {
        //     title: t("Log"),
        //     render: (record, index) => (<>
        //         {record.supportId !== null && record.assignedDate != null ? (
        //             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        //                 <Tooltip title="Click to view Log">
        //                     <button className="acknowledge-btn btn btn-primary px-2 py-1" onClick={(e) => handleSupportLog(record.supportId)}>
        //                         <img style={{ filter: "invert(0) brightness(2)" }} src={LogIcon} alt="LogDetails" /></button>
        //                 </Tooltip>
        //             </div>

        //         ) : ''}
        //     </>)
        // }
        {
            title: t("Action"),
            dataIndex: "",
            render: (record, index) => (
                <Dropdown className="action-dropdown"
                    overlay={
                        <Menu>
                            <Menu.Item key="ClicktoviewLog" onClick={(e) => handleSupportLog(record.supportId)}>
                                <button className="table-btn" >
                                    <img src={LogIcon} alt="LogDetails" width={20} height={20} /></button>
                                {t("Log")}
                            </Menu.Item>
                            {userRole && userRole === "SuperAdmin" ?
                                <Menu.Item key="delete" onClick={(e) => handleDeleteSupportItem(record.supportId)}>
                                    <button className="table-btn" >
                                        <img src={Trash_light} alt="LogDetails" width={20} height={20} /></button>
                                    {t("Delete")}
                                </Menu.Item> : ""
                            }
                        </Menu>
                    }
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <a className="ant-dropdown-link d-flex justify-content-between align-items-center" onClick={e => e.preventDefault()}>
                        <span>{t("Actions")} </span>
                        {/*<DownOutlined style={{ fontSize: '8px' }}*/}
                        {/*/>*/}
                    </a>
                </Dropdown>
            )
        },
    ]

    const disableFutureDates = (current) => {
        const today = moment().startOf('day'); // Get today's date without time
        return current && current.isAfter(today, 'day'); // Disable dates after today
    };

    const onChange = (dateString) => {
        const combinedStartDate = dateString ? dayjs(dateString) : null;
        setRangeStart(combinedStartDate);
    };

    const onChangeEndRange = (dateString) => {
        const combinedEndDate = dateString ? dayjs(dateString) : null;
        setRangeEnd(combinedEndDate);
    };

    const handleAutoRefreshToggle = () => {
        setAllowAutoRefresh(!allowAutoRefresh);
    };

    const handleInputForUserDropdown = (input) => {

        const filtered = allUserSupportData && allUserSupportData.filter(item => {
            const fullName = `${item.lastName} ${item.firstName}`;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredUserOptions(filtered);
    };

    // Runs when `allowAutoRefresh` changes
    useEffect(() => {
        if (allowAutoRefresh) {
            // Clear any existing interval before starting a new one
            clearInterval(intervalRef.current);

            // Call both functions immediately when enabled
            getSupportDetails();
            getworkitemsupportdetails();

            // Store a single interval reference
            intervalRef.current = setInterval(() => {
                getSupportDetails();
                getworkitemsupportdetails();
            }, 5000);
        } else {
            // Clear interval if disabled
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        return () => {
            clearInterval(intervalRef.current);
        }; // Cleanup on component unmount
    }, [allowAutoRefresh]);

    return (
        <div>
            <Title title="Support Request"></Title>
            {roleName == null || supportUser === null || supportUser === undefined ? <Loader /> :
                roleId && roleId != 7 && !supportUser
                   ? <NotAuthorised></NotAuthorised> :
                <>
                    <Layout supportCount={newSupportCount}>
                        <section className="Company_section common pt-3">
                            {allowAutoRefresh ? '' : (loading ? <Loader /> : '')}

                            <Toaster />
                            <Breadcrumb
                                itemRender={(route, params, routes, paths) => (
                                    route.path ? (
                                        <Link to={route.path}>
                                            {route.breadcrumbName}
                                        </Link>
                                    ) : (
                                        <span>{route.breadcrumbName}</span>
                                    )
                                )}

                                items={[
                                    {
                                        breadcrumbName: 'Dashboard',
                                        path: '/Dashboard',
                                    },
                                    {
                                        breadcrumbName: 'Support',
                                        path: ''
                                    },
                                    {
                                        breadcrumbName: 'Request',
                                        path: ''
                                    },
                                ]}
                            />
                            <div className="report-header report-header d-flex justify-content-between align-items-center mb-2">
                                <div className="load-report">
                                    <div className="search-order-outer">
                                        <Space direction="vertical">
                                            <DatePicker
                                                format="MM/DD/YYYY HH:mm:ss"
                                                showTime
                                                disabledDate={disableFutureDates}
                                                placeholder={t("SelectStartDateandTime")}
                                                onChange={onChange}
                                                value={rangeStart}
                                                renderExtraFooter={() => (
                                                    <div className="timePickerHeader">
                                                        <div>Hr</div>
                                                        <div>Min</div>
                                                        <div>Sec</div>
                                                    </div>
                                                )}
                                            />
                                        </Space>
                                        <Space direction="vertical">
                                            <DatePicker
                                                format="MM/DD/YYYY HH:mm:ss"
                                                showTime
                                                disabledDate={disableFutureDates}
                                                placeholder={t("SelectEndDateandTime")}
                                                onChange={onChangeEndRange}
                                                value={rangeEnd}
                                                renderExtraFooter={() => (
                                                    <div className="timePickerHeader">
                                                        <div>Hr</div>
                                                        <div>Min</div>
                                                        <div>Sec</div>
                                                    </div>
                                                )}
                                            />
                                        </Space>
                                        <Tooltip title={t("Clicktosearchrequest")}>
                                            <button onClick={handleSearchRequest}
                                                className="search-button-icon"
                                                disabled={(rangeStart === '' || rangeStart === null) && (rangeEnd === '' || rangeEnd === null)}
                                            ><img src={searchIcon} /></button>
                                        </Tooltip>

                                        {resetDisplay ?
                                            <Tooltip title={t("Clicktoreset")}>
                                                <button onClick={handleResetSearch} className="reload-button-icon"><img src={ReloadIcon} /></button>
                                            </Tooltip>
                                            : ''}
                                    </div>
                                </div>

                                <div className="view-report">
                                    <div className="alarm-toggle--wrap d-inline-flex align-items-center gap-2">
                                        <label className="alarm-toggle-label mb-0">Auto refresh</label>
                                        <Switch
                                            id="allowNotifications"
                                            //  className="ms-2"
                                            checked={allowAutoRefresh}
                                            onChange={handleAutoRefreshToggle}
                                        />
                                    </div>

                                        <div>
                                            {roleName && roleName == "SuperAdmin" ?
                                                <Tooltip title="Click to add support">
                                                    <GroupAddIcon onClick={() => handleAddSupportClick()}
                                                        style={{
                                                            color: '#fff',
                                                            height: '30px',
                                                            width: '30px',
                                                            border: '1px solid #fff',
                                                            borderRadius: '4px',
                                                            padding: '4px',
                                                            cursor: 'pointer',
                                                        }}
                                                    />
                                                </Tooltip> : ""
                                            }

                                        {showAddSupport && (
                                            <AddManualSupport
                                                showSupportModal={showSupportModal}
                                                handleShowModalClose={handleShowModalClose}
                                            />
                                        )}
                                    </div>

                                    <div>
                                        <Tooltip title={t("Clicktodownloadsupportrequest")}>
                                            <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', color: '#fff', height: '30px', width: '30px', border: '1px solid #fff', borderRadius: '4px', padding: '4px', cursor: 'pointer' }} onClick={() => exportAsExcel(true)}>
                                                <img style={{ filter: 'invert(3) brightness(9)' }} src={XLSIcon} /></button>
                                        </Tooltip>
                                    </div>

                                    <Tooltip title={t("Clicktoloadsupportrequest")}>
                                        <RestartAltIcon onClick={() => openloadreport()} style={{ color: '#fff', height: '30px', width: '30px', border: '1px solid #fff', borderRadius: '4px', padding: '4px', cursor: 'pointer' }} />
                                    </Tooltip>
                                    {roleName && roleName == "SuperAdmin" || roleName && roleName == "Developer" ?

                                        <div>

                                            <Tooltip title={t("Clicktoviewsupportreport")}>
                                                <EqualizerIcon onClick={() => opensupportreport()} style={{ color: '#fff', height: '30px', width: '30px', border: '1px solid #fff', borderRadius: '4px', padding: '4px', cursor: 'pointer' }} />
                                            </Tooltip>
                                        </div>
                                        :
                                        ""
                                    }
                                </div>
                            </div>



                            <Collapse className="bg-color-orange ml-3 mr-3 mt-3"
                                defaultActiveKey={['2']}
                                items={[
                                    {
                                        key: '2',
                                        label: <div>{t("NewRequests")} <span className="float-right">{t("TotalCount")}: {assignedoptions.pagination.total}</span></div>,
                                        children: <div className="w-100 justify-content-center">
                                            <div className="Viewer-table index--table position-relative blank-row-tb common-table mb-4">
                                                <Table
                                                    className='table-responsive antd--detail-table1 support assgin-table'
                                                    columns={assignedcolumns}
                                                    dataSource={assignedtable}
                                                    pagination={assignedoptions.pagination.total > REACT_APP_SUPPORT_PAGESIZE ? assignedoptions.pagination : false}
                                                    onChange={handleAssignedChange}
                                                    // scroll={{ x: "250px" }}
                                                    paginationTotalRows={total}
                                                />
                                            </div>
                                        </div>,
                                    },
                                ]}
                            />

                            <Collapse className="bg-color-orange ml-3 mr-3 mt-3"
                                defaultActiveKey={['3']}
                                items={[
                                    {
                                        key: '3',
                                        label: <div>{t("OpenRequests")} <span className="float-right">{t("TotalCount")}: {acknowledgedoptions.pagination.total}</span></div>,
                                        children: <div className="w-100 justify-content-center"><div className="Viewer-table index--table position-relative blank-row-tb common-table mb-4">
                                            <Table
                                                className='table-responsive antd--detail-table1 support'
                                                columns={acknowledgedcolumns}
                                                dataSource={acknowledgedtable}
                                                pagination={acknowledgedoptions.pagination.total > REACT_APP_SUPPORT_PAGESIZE ? acknowledgedoptions.pagination : false}
                                                onChange={handleAcknowledgedChange}
                                                //  scroll={{ x: "250px" }}
                                                paginationTotalRows={total}
                                            />
                                        </div>
                                        </div>,
                                    },
                                ]}
                            />

                            <Collapse className="bg-color-orange ml-3 mr-3 mt-3"
                                defaultActiveKey={['3']}
                                items={[
                                    {
                                        key: '3',
                                        label: <div>{t("ClosedRequests")}<span className="float-right">{t("TotalCount")}: {closedoptions.pagination.total}</span></div>,
                                        children: <div className="w-100 justify-content-center"><div className="Viewer-table index--table position-relative common-table mb-4">
                                            <Table
                                                className='table-responsive antd--detail-table1 support'
                                                columns={closedcolumns}
                                                dataSource={closedtable}
                                                pagination={closedoptions.pagination.total > REACT_APP_SUPPORT_PAGESIZE ? closedoptions.pagination : false}
                                                onChange={handleClosedChange}
                                                //  scroll={{ x: "250px" }}
                                                paginationTotalRows={total}
                                            />
                                        </div>
                                        </div>,
                                    },
                                ]}
                            />

                            <Drawer
                                title={
                                    <div className="drawer-title-container supportdrawer">
                                        <div className="drawer-title-left">
                                            <div className="drawer-user-icon">
                                                <UserOutlined />
                                            </div>
                                            <Typography.Text className="drawer-title-text">
                                                Assign User For Support Request
                                            </Typography.Text>
                                        </div>
                                        <Button
                                            type="link"
                                            icon={<CloseOutlined style={{ color: "#FFFFFF" }} />}
                                            onClick={handleDrawerClose}
                                            className="drawer-close-icon"
                                        />
                                    </div>


                                }

                                placement="right"
                                onClose={handleDrawerClose}
                                open={isDrawerOpen}
                                width={500}
                                closable={false}
                                className="associated-sites"
                            >
                                <div class="add-support-model">
                                    <div class="row">
                                        <div className="col-md-12">
                                            <div className="support-user-box">
                                                <div className="form-group">
                                                    <p className="custom-label ">Select user <span className="required-fields"> * </span></p>

                                                    <Select className="w-100"
                                                        aria-label=".form-select-lg example"
                                                        placeholder="Select User"
                                                        showSearch
                                                        value={supportuserId}
                                                        onChange={(value) => {
                                                            setSupportUserId(value)

                                                        }}
                                                        onSearch={(value) => {
                                                            handleInputForUserDropdown(value)
                                                        }}
                                                        filterOption={false}
                                                    >
                                                        {filteredUserOptions.length > 0 ?
                                                            filteredUserOptions && filteredUserOptions.map(item =>
                                                                <Option key={item.userId} value={item.userId}>
                                                                    {`${item.lastName} ${item.firstName}`}
                                                                </Option>
                                                            )
                                                            :
                                                            allUserSupportData && allUserSupportData.map(item =>
                                                                <Option key={item.userId} value={item.userId}>
                                                                    {`${item.lastName} ${item.firstName}`}
                                                                </Option>
                                                            )
                                                        }
                                                    </Select>
                                                </div>
                                                {allowAutoRefresh ? '' : (loading ? <Loader /> : '')}
                                                <div className="d-flex justify-content-end w-100">
                                                    <button className="btn btn-primary"
                                                        onClick={UpdateUserManually}
                                                        disabled={!supportuserId}
                                                    >Assign</button>
                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                </div>

                            </Drawer>

                            <div className="chat-box-outer">
                                <div className="chat-box-outer">
                                    {chatBoxes.map((chat, index) => {
                                        return (

                                            <ChatBox
                                                key={chat?.id}
                                                content={chat?.data}
                                                onClose={() => closeChatBox(chat?.id)}
                                                className={chat?.id && exitingChatBoxes.includes(chat?.id) ? "chatbox-exit" : "chatbox-enter"}
                                                loginUserName={loginUserName}
                                                receiverUserName={chat?.data?.requestedBy}
                                                userEmailId={EmailId}
                                                loginuserId={loginuserId}
                                                supportId={chat?.data?.supportId}
                                                receiverById={chat?.data?.requestedById}
                                                responseType={chat?.data.requestType}
                                                phoneNumber={chat?.data.phoneNumber}

                                            />
                                        );
                                    })}
                                </div>
                            </div>

                            {audioCallInitiated && <AudioCall
                                content={audioCallContent}
                                technician={loginUserName}
                                cancelCall={cancelCall}
                            />}

                        </section>
                    </Layout>

                    <Modal
                        show={updateModal}
                        onHide={handleUpdateModalClose}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="modal-dialog-copy"
                    >
                        <Modal.Body>
                            <div class="copy-model">
                                <h5> {t("Areyousureyouwanttoupdate?")}</h5>
                                <div class="w-100 mt-3 btn-yesno d-flex justify-content-end">
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        onClick={() => UpdateStatusData(supportId)}
                                    >
                                        {t("Yes")}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-primary ml-2"
                                        onClick={handleUpdateModalClose}
                                    >
                                        {t("No")}
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal
                        show={applyModal}
                        onHide={handleApplyModalClose}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="modal-dialog-copy"
                    >
                        <Modal.Body>
                            <div class="copy-model">
                                <h5> {t("Areyousureyouwanttoupdate?")}</h5>
                                <div class="w-100 mt-3 btn-yesno d-flex justify-content-end">
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        onClick={() => UpdatePriority(applyId)}
                                    >
                                        {t("Yes")}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-primary ml-2"
                                        onClick={handleApplyModalClose}
                                    >
                                        {t("No")}
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>



                    <Modal
                        show={acknowledgeModal}
                        onHide={handleAcknowledgeModalClose}
                        backdrop="static"
                        keyboard={false}
                        dialogClassName="modal-dialog-copy"
                    >
                        <Modal.Body>
                            <div class="copy-model">
                                <h5> {t("Areyousureyouwanttoacknowledgethesupportrequest?")}</h5>
                                <div class="w-100 mt-3 btn-yesno d-flex justify-content-end">
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        onClick={() => UpdateAssignedData(acknowledgeId)}
                                    >
                                        {t("Yes")}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-primary ml-2"
                                        onClick={handleAcknowledgeModalClose}
                                    >
                                        {t("No")}
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal
                        show={supportAttachmentModal}
                        onHide={handleAcknowledgeModalClose}
                        backdrop="static"
                        keyboard={false}
                        size="sm"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: '1rem' }}>{t("SupportAttachments")}</Modal.Title>
                            <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body className="d-flex justify-content-center align-items-center">

                            <div>
                                {isImage(AttachmentSrc) ? (
                                    <Tooltip title={t("PreviewImages")}>
                                        <button onClick={() => handleCarouselImageClick(Attachment.IMAGE)} className="btn btn-primary mr-2">
                                            <CollectionsIcon style={{ color: '#fff', height: '25px', width: '25px', cursor: 'pointer' }}  ></CollectionsIcon>
                                        </button>
                                    </Tooltip>
                                ) : ''}
                                {isVideo(AttachmentSrc) ? (
                                    <Tooltip title={t("PreviewVideos")}>
                                        <button onClick={() => handleCarouselImageClick(Attachment.VIDEO)} className="btn btn-primary mr-2">
                                            <OndemandVideoIcon style={{ color: '#fff', height: '25px', width: '25px', cursor: 'pointer' }} ></OndemandVideoIcon>
                                        </button>
                                    </Tooltip>

                                ) : ''}
                                {isDocument(AttachmentSrc) ? (
                                    <Tooltip title={t("PreviewDocuments")}>
                                        <button onClick={() => handleCarouselImageClick(Attachment.DOCUMENT)} className="btn btn-primary mr-2">
                                            <PictureAsPdfIcon style={{ color: '#fff', height: '25px', width: '25px', cursor: 'pointer' }} ></PictureAsPdfIcon>
                                        </button>
                                    </Tooltip>
                                ) : ''}

                                {/*{*/}
                                {/*    AttachmentSrc && AttachmentSrc.length > 0 && isAudio(AttachmentSrc) ? (*/}
                                {/*        <Tooltip title="Listen Audio">*/}
                                {/*            <button onClick={() => playAudio(AttachmentSrc[0].source, Attachment.VOICE)} className="btn btn-primary">*/}
                                {/*                <MicIcon style={{ color: '#fff', height: '25px', width: '25px', cursor: 'pointer' }} />*/}
                                {/*            </button>*/}
                                {/*        </Tooltip>*/}
                                {/*    ) : null*/}
                                {/*}*/}
                                {isAudio(AttachmentSrc) ? (
                                    <Tooltip title={t("ListenAudio")}>
                                        <button onClick={() => handleCarouselImageClick(Attachment.VOICE)} className="btn btn-primary">
                                            <MicIcon style={{ color: '#fff', height: '25px', width: '25px', cursor: 'pointer' }} ></MicIcon>
                                        </button>
                                    </Tooltip>
                                ) : ''}
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showCarouselModal} size='lg'>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("Attachments")}</Modal.Title>
                            <button type="button" className="close" aria-label="Close" onClick={handleCarouselModalClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="carousel-container">
                                {attachmentType && attachmentType == Attachment.IMAGE ? (
                                    <>
                                        <Carousel activeIndex={currentIndex} onSelect={handleSelect} slide={false} interval={null} prevLabel={null} nextLabel={null} controls={AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId == attachmentType).length > 1}>
                                            {AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId === attachmentType).map((attachment, index) => (
                                                <Carousel.Item key={index}>
                                                    <div className="row">
                                                        <div className="col-md-12" style={{ maxWidth: '95%' }}>
                                                            <Tooltip title={t("Download")}><button className="btn btn-primary mb-2 float-right" onClick={() => onDownloadButtonClick(attachment.source)}><FileDownloadOutlinedIcon fontSize="medium" /></button></Tooltip>

                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-center">
                                                            <img
                                                                style={{ width: '100%', maxWidth: '90%' }}
                                                                src={attachment.source}
                                                                alt={`Attachment ${index + 1}`}
                                                            />
                                                        </div>
                                                    </div>

                                                </Carousel.Item>
                                            ))}
                                        </Carousel>
                                    </>
                                ) : attachmentType && attachmentType == Attachment.VIDEO ? (
                                    <Carousel activeIndex={currentIndex} onSelect={handleSelect} slide={false} interval={null} prevLabel={null} nextLabel={null} controls={AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId == attachmentType).length > 1}>
                                        {AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId === attachmentType).map((attachment, index) => (
                                            <Carousel.Item key={index} className="text-center">
                                                <video controls style={{ width: '100%', maxWidth: '90%', height: 'auto' }}>
                                                    <source src={attachment.source} alt={`Attachment ${index + 1}`} type="video/mp4" />
                                                    {t("Yourbrowserdoesnotsupportthevideotag.")}
                                                </video>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>

                                ) : attachmentType && attachmentType == Attachment.DOCUMENT ? (
                                    <Carousel activeIndex={currentIndex} onSelect={handleSelect} slide={false} interval={null} prevLabel={null} nextLabel={null} controls={AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId == attachmentType).length > 1}>
                                        {AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId === attachmentType).map((attachment, index) => (
                                            <Carousel.Item key={index} className="text-center">
                                                <iframe
                                                    src={attachment.source}
                                                    title="PDF Viewer"
                                                    className="pdf-viewer"
                                                    style={{ width: '90%', height: '70vh', border: 'none' }}
                                                />
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>

                                ) : attachmentType && attachmentType == Attachment.VOICE ? (
                                    <Carousel activeIndex={currentIndex} onSelect={handleSelect} slide={false} interval={null} prevLabel={null} nextLabel={null} controls={AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId == attachmentType).length > 1}>
                                        {AttachmentSrc && AttachmentSrc.filter(attachment => attachment.fileTypeId === attachmentType).map((attachment, index) => (
                                            <Carousel.Item key={index} className="text-center">
                                                <audio controls style={{ width: '90%' }} onClick={() => playAudio(attachment.source)}>
                                                    <source src={attachment.source} type="audio/mpeg" />
                                                    {t("Yourbrowserdoesnotsupporttheaudioelement.")}
                                                </audio>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>

                                ) : (
                                    // Render default content when attachmentType is neither 1 nor 2
                                    <div>{t("Noattachmentstodisplay")}</div>
                                )}
                            </div>
                        </Modal.Body>
                    </Modal>

                </>
            }
        </div>
    );
}

export default connect()(SupportIndex);